module.exports = __webpack_public_path__ + "static/story2-menu-thumbnails-400x400-3e3b21b3277208efa312d01893665036.jpg";